<app-loading-splash-screen class="app-s"></app-loading-splash-screen>
<router-outlet></router-outlet>